import React from 'react';
import './error-message.scss';
import DOMPurify from 'dompurify';

interface Props {
    errorMessage: string;
}

export const ErrorMessage = (props: Props) => {
    return (
        <div
            className="error-message"
            dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(props.errorMessage),
            }}
        ></div>
    );
};
